import { Button } from '@/components/ui/button';
import { Progress } from '@/components/ui/progress';
import { motion } from 'framer-motion';
import { ChevronLeft } from 'lucide-react';

export const ModuleHeader = ({
  title,
  currentStep,
  totalSteps,
  onBack,
}) => {
  const progressPercent = totalSteps > 0 ? (currentStep / totalSteps) * 100 : 0;

  return (
    <div className="bg-card border-b border-border px-4 pt-1.5 pb-3">
      {/* Navigation row: Back | Title | Steps */}
      <div className="flex items-center justify-between gap-2 mb-2">
        <Button
          variant="ghost"
          size="sm"
          onClick={onBack}
          className="h-8 w-8 p-0 rounded-full hover:bg-muted shrink-0"
        >
          <ChevronLeft size={20} className="text-foreground" />
        </Button>

        <h2 className="text-[13px] font-bold font-heading text-foreground text-center flex-1 truncate px-1">
          {title}
        </h2>

        <div className="text-[11px] font-bold text-muted-foreground font-heading shrink-0 min-w-[35px] text-right">
          {currentStep + 1}/{totalSteps}
        </div>
      </div>

      {/* Progress bar */}
      <motion.div
        initial={{ opacity: 0, scaleX: 0.8 }}
        animate={{ opacity: 1, scaleX: 1 }}
        className="origin-left"
      >
        <Progress
          value={progressPercent}
          className="h-1.5 bg-muted"
        />
      </motion.div>
    </div>
  );
};
